import type { Resource } from '../../';
export const checkout_shipping_errors_nameTooLong: Resource = {"default":"First Name and Last Name fields are limited to 30 characters total."};
